export class Languages {
    static FR = 'fr';
    static EN = 'en';
}

Object.freeze(Languages);